import {GameClientUserState} from '@colonist/game-base-types'
import React, {createContext, useContext, useMemo} from 'react'

interface UIGameUserStatesContextProps {
    userStates: GameClientUserState[]
    hasOnlyOneHumanPlayer: boolean
}

const UIGameUserStatesContext = createContext<UIGameUserStatesContextProps | undefined>(undefined)

export function useUIGameUserStatesContext() {
    const context = useContext(UIGameUserStatesContext)
    if(!context) throw new Error('UIGameUserStatesContext not found')
    return context
}

export function UIGameUserStatesProvider({
    children,
    userStates,
}: {
    children: React.ReactNode
    userStates: GameClientUserState[]
}) {
    const hasOnlyOneHumanPlayer = useMemo(() => userStates.filter((userState) => !userState.isBot).length === 1, [userStates])

    const contextValue = useMemo(() => ({
        userStates: userStates,
        hasOnlyOneHumanPlayer: hasOnlyOneHumanPlayer,
    }), [userStates, hasOnlyOneHumanPlayer])

    return (
        <UIGameUserStatesContext.Provider value={contextValue}>
            {children}
        </UIGameUserStatesContext.Provider>
    )
}
